import BaseAPI from '../base'

function getTaxes(cafe_id) {
    return BaseAPI.get(`/taxes/list/${cafe_id}`);
}

function addTax(data) {
    return BaseAPI.post(`/taxes/create`, data);
}

function removeTax(id) {
    return BaseAPI.post(`/taxes/remove/${id}`);
}

function updateTax(id, data) {
    return BaseAPI.post(`/taxes/update/${id}`, data);
}

export default {
    getTaxes,
    addTax,
    removeTax,
    updateTax
}